import React from 'react';
import CrmAttributesPage from '../components/CrmAttributesPage';

const CrmAttributesApp = (props) => <CrmAttributesPage {...props} />;

export default CrmAttributesApp;
